import { useEffect } from 'react';

import { featureFlagsSelectors } from 'app-components/flux/feature-flags';
import { updatePreferenceOverride } from 'app-components/flux/preferences-v2/preferencesV2Actions';
import { getPreferenceObj } from 'app-components/flux/preferences-v2/preferencesV2Selectors';
import { useAppDispatch, useAppSelector } from 'app-components/hooks/redux';

/**
 * When the contextual prompt chips rollout flag is on, persist opt-in for users who
 * have not explicitly turned the feature off.
 */
export const useAutoEnableAiContextualPromptChips = (): void => {
  const dispatch = useAppDispatch();
  const rolloutEnabled = useAppSelector((state) =>
    Boolean(featureFlagsSelectors.getFeatureFlag(state, 'aiContextualPromptChips')),
  );
  const preference = useAppSelector((state) => getPreferenceObj(state, 'aiContextualPromptChipsEnabled'));
  const preferenceValue = preference?.value;
  const preferenceId = preference?.preferenceId;
  const dataType = preference?.dataType;

  useEffect(() => {
    if (!rolloutEnabled) {
      return;
    }

    if (preferenceValue === false) {
      return;
    }

    if (preferenceValue !== true) {
      dispatch(
        updatePreferenceOverride({
          id: 'aiContextualPromptChipsEnabled',
          preferenceName: 'aiContextualPromptChipsEnabled',
          preferenceId,
          dataType: dataType ?? 'BOOLEAN',
          value: true,
        }),
      );
    }
  }, [dataType, dispatch, preferenceId, preferenceValue, rolloutEnabled]);
};
